module.exports = __webpack_public_path__ + "static/img/calendar-car.19b747bb.svg";